var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1140"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1140"
    },
    "bundlingPackage": "pricing-pages-ui-public-app",
    "bundlingPackageVersion": "static-1.12835",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};